export default function isRtlLanguage(locale) {    
    // Same list as used by Flutter to keep it consistent
    return locale === 'ar' // Arabic
        || locale === 'fa' // Farsi
        || locale === 'he' // Hebrew
        || locale === 'ps' // Pashto
        || locale === 'ur' // Urdu
        ;
}